import React from "react";
const UnloadingTables = ({ data }) => {
  return <div> unloading table</div>;
};
export default UnloadingTables;
